import { render, staticRenderFns } from "./testpostDetail.vue?vue&type=template&id=711696b5&"
import script from "./testpostDetail.vue?vue&type=script&lang=js&"
export * from "./testpostDetail.vue?vue&type=script&lang=js&"
import style0 from "./testpostDetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports